import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { RoleGuard } from '../core/guards/role.guard';
import { ROLES } from '../core/constants/roles.constants';

export const REMOTE_ROUTES: Routes = [
  {
    path: 'remote-actions/list',
    loadComponent: () =>
      import('../features/remote-actions/list/list.component').then(m => m.RemoteActionsListComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'scheduled-reprovisionings/list',
    loadComponent: () =>
      import('../features/scheduled-reprovisionings/list/list.component').then(
        m => m.ScheduledReprovisioningsListComponent
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'provisioning/hub',
    loadComponent: () =>
      import('../features/provisioning/hub/provisioning-hub.component').then(m => m.ProvisioningHubComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'remote-control',
    loadComponent: () => import('../features/remote-control/remote-control.component').then(m => m.RemoteControlComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
];
